import {useMemo} from 'react';
import {getCurrentMonth, getCurrentYear, toMonthISO} from './date';
import {useSelector} from 'react-redux';
import {useSearchParams} from 'react-router-dom';

/**
 * Returns the selected period, search param period, or defaults to now.
 */
export const useParamReportPeriodOrDefault = () => {
  const [searchParams] = useSearchParams();
  const selectedPeriod = useSelector((state) => state.periods.selectedPeriod);

  const period = useMemo(() => {
    if (selectedPeriod) {
      return selectedPeriod;
    }
    const urlPeriod = searchParams.get('period');
    if (urlPeriod) {
      return urlPeriod;
    }

    return toMonthISO(getCurrentYear(), getCurrentMonth());
  }, [selectedPeriod, searchParams]);

  return period;
};
